import { FormattedMessage } from 'react-intl';
import servicesTeamImg from '../../../../assets/services-team.jpg';
import css from './TrustedExperts.module.css';

const TrustedExperts = () => {
  return (
    <section className={css.trustedSection}>
      <div className={css.trustedContainer}>
        <div className={css.trustedImage}>
          <img src={servicesTeamImg} alt="Trusted service experts team" />
        </div>
        <div className={css.trustedContent}>
          <h3 className={css.trustedTitle}>
            <FormattedMessage id="LandingPage.Trusted.title" />
          </h3>
          <p className={css.trustedDescription}>
            <FormattedMessage id="LandingPage.Trusted.description" />
          </p>
          <div className={css.trustPoints}>
            {[1, 2, 3, 4].map(i => (
              <div key={i} className={css.trustPoint}>
                <span className={css.checkmark}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-check w-6 h-6 text-green-600 flex-shrink-0 mt-1"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5"></path>
                  </svg>
                </span>
                <p>
                  <FormattedMessage id={`LandingPage.Trusted.point${i}`} />
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedExperts;
